// extracted by mini-css-extract-plugin
module.exports = {"accessTag":"Tag_accessTag__lbyw_","gray":"Tag_gray__7Xq39","blue":"Tag_blue__1YKqt","green":"Tag_green__2CHHy","wrapper":"Tag_wrapper__1mLLo","default":"Tag_default__3ahEZ"};